<!-- components/ToastContainer.vue -->
<template>
  <div class="toast-container position-fixed p-3" style="top: 1rem; right: 1rem; z-index: 1050;">
    <Toast
      v-for="(toast, index) in toasts"
      :key="toast.id"
      :type="toast.type"
      :message="toast.message"
      :duration="toast.duration"
      @closed="removeToast(index)"
    />
  </div>
</template>

<script>
import Toast from "./Toast.vue";

export default {
  name: "ToastContainer",
  components: { Toast },
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    addToast(toast) {
      toast.id = Date.now() + Math.random();
      this.toasts.push(toast);
    },
    removeToast(index) {
      this.toasts.splice(index, 1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ToastContainer.vue